import SectionHead from "@/components/SectionHead";
import { MessageSquareText, Palette, Code2, Rocket, TrendingUp } from "lucide-react";
import { useLang } from "@/i18n";

const ICONS = [MessageSquareText, Palette, Code2, Rocket];

const HowItWorks = () => {
  const t = useLang().t;
  return (
  <section id="how-it-works" data-testid="how-it-works" className="bg-[#F5F2EB] py-16 sm:py-24">
    <div className="container-site">
      <SectionHead
        testId="how-it-works-head"
        eyebrow={t.steps.eyebrow}
        title={t.steps.title}
        sub={t.steps.sub}
      />
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {t.steps.items.map((s, i) => {
          const Icon = ICONS[i];
          return (
          <div key={s.title} data-testid={`step-${i + 1}`} className="relative card-site p-6 sm:p-7">
            <span className="absolute -top-3 left-6 rounded-full bg-[#4A362E] px-3 py-1 font-heading text-xs font-bold text-white">
              {t.steps.stepLabel} {i + 1}
            </span>
            <div className="mt-2 flex h-11 w-11 items-center justify-center rounded-xl bg-[#F5F2EB]">
              <Icon className="h-5 w-5 text-[#A88667]" />
            </div>
            <h3 className="mt-4 font-heading text-base sm:text-lg font-bold text-[#3E2723]">{s.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-[#5D4037]">{s.desc}</p>
          </div>
          );
        })}
      </div>
      <div className="mt-8 flex items-center justify-center gap-3 rounded-2xl border border-dashed border-[#D7B594] bg-[#FDFBF7] px-6 py-5 text-center">
        <TrendingUp className="h-5 w-5 shrink-0 text-[#A88667]" />
        <p className="text-sm sm:text-base font-medium text-[#5D4037]">
          {t.steps.growPre} <span className="font-heading font-bold text-[#3E2723]">{t.steps.growBold}</span>{t.steps.growPost}
        </p>
      </div>
    </div>
  </section>
  );
};

export default HowItWorks;
